import { render } from "./InviteImgDialog.vue?vue&type=template&id=63692416&scoped=true"
import script from "./InviteImgDialog.vue?vue&type=script&lang=js"
export * from "./InviteImgDialog.vue?vue&type=script&lang=js"

import "./InviteImgDialog.vue?vue&type=style&index=0&id=63692416&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63692416"]])

export default __exports__